if (!customElements.get('variant-option')) {
  class VariantOption extends HTMLElement {
    constructor() {
      super();

      this.optionText = this.querySelector('.js-option-text')
      this.handleChangeRef = this.handleChange.bind(this);
      this.handleSwatchChange = this.handleSwatchChange.bind(this)
    }

    handleChange(event) {
      this.updateATCButton();
      document.dispatchEvent(new CustomEvent('alexa:variant-option-change', { detail: {
        value: event.target.value,
        index: this.getAttribute('data-option'),
        productId: this.getAttribute('data-product-id'),
        productHandle: this.getAttribute('data-product-handle'),
      }}));
    }

    handleSwatchChange(event) {
      if (!this.optionText) return
      this.optionText.textContent = event?.detail?.colorText || ''
    }

    updateATCButton() {
      const colorEl = document.querySelector('input[class="swatch__input"]:checked');
      const sizeEl = document.querySelector('input[class="size__input"]:checked');
      if (!colorEl || !sizeEl) return;

      let color = colorEl.value;
      let size = sizeEl.value;
      let variantOptions = document.querySelectorAll(".product__select option");
      
      const selectedOption = Array.from(variantOptions).filter(option => {
        return option.getAttribute("data-option-color") === color && option.getAttribute("data-option-size") === size;
      })[0];

      const atcButton = document.getElementById("atc_button");
      if (selectedOption && atcButton) {
        atcButton.textContent = selectedOption.dataset.atcText || atcButton.dataset.addToBag || "ADD TO BAG";
      }
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleChangeRef);
      this.removeEventListener('alexa:swatch-change', this.handleSwatchChange)
    }

    connectedCallback() {
      this.addEventListener('change', this.handleChangeRef);
      this.addEventListener('alexa:swatch-change', this.handleSwatchChange)
    }
  }

  customElements.define('variant-option', VariantOption);
}